export default __webpack_public_path__ + "static/media/Alpha-FX-A-White.e6ec024b.png";